import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'onyx-data-preview',
  imports: [TranslatePipe],
  templateUrl: './onyx-data-preview.component.html',
  styleUrl: './onyx-data-preview.component.scss',
})
export class OnyxDataPreviewComponent {
  public readonly heading = input<string>();
  public readonly error = input(false);
}
